module.exports = __webpack_public_path__ + "img/2023_Cell.945eab08.png";